// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;
}

/* Navbar - styles are largely handled by Tailwind in Navbar.js, but keeping defaults safe */
.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background-color: #0f172a;
  /* slate-950 */
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.5);
  border-bottom: 1px solid #1e293b;
  /* slate-800 */
}

.nav-brand {
  font-size: 1.5rem;
  font-weight: bold;
  text-decoration: none;
  color: #fff;
}

.nav-links a,
.nav-links button {
  margin-left: 1.5rem;
  text-decoration: none;
  color: #94a3b8;
  /* slate-400 */
  font-size: 1rem;
  background: none;
  border: none;
  cursor: pointer;
  transition: color 0.2s;
}

.nav-links a:hover,
.nav-links button:hover {
  color: #fff;
}

/* Forms */
.form-container {
  max-width: 400px;
  margin: 2rem auto;
  padding: 2rem;
  background: #1e293b;
  /* slate-800 */
  border-radius: 16px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.5);
  border: 1px solid #334155;
  /* slate-700 */
}

.form-container h2 {
  margin-top: 0;
  text-align: center;
  color: #fff;
}

.form-container input,
.form-container textarea,
.form-container select {
  width: 100%;
  padding: 0.8rem;
  margin-bottom: 1rem;
  border-radius: 8px;
  border: 1px solid #334155;
  /* slate-700 */
  background: #0f172a;
  /* slate-950 */
  color: #fff;
  box-sizing: border-box;
}

.form-container input:focus,
.form-container textarea:focus,
.form-container select:focus {
  outline: 2px solid #6366f1;
  /* indigo-500 or similar */
  border-color: #6366f1;
}

.form-container button {
  width: 100%;
  padding: 0.8rem;
  border: none;
  background: linear-gradient(to right, #4f46e5, #9333ea);
  color: white;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  transition: opacity 0.2s;
}

.form-container button:hover {
  opacity: 0.9;
}

.error {
  color: #f87171;
  /* red-400 */
  text-align: center;
  margin-top: 1rem;
}

/* Job List */
.job-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
}

.job-card {
  background: #1e293b;
  /* slate-800 */
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  border: 1px solid #334155;
  /* slate-700 */
  color: #fff;
}

.job-card h2 {
  margin-top: 0;
  color: #f8fafc;
  /* slate-50 */
}

.job-card p {
  color: #cad4e0;
  /* slate-300 */
}

.job-card a {
  margin-top: auto;
  align-self: flex-end;
  text-decoration: none;
  color: #818cf8;
  /* indigo-400 */
  font-weight: bold;
}

/* Job Detail */
.job-detail-container {
  background: #1e293b;
  /* slate-800 */
  padding: 2rem;
  border-radius: 12px;
  border: 1px solid #334155;
  /* slate-700 */
  color: #fff;
}

.applications-section {
  margin-top: 2rem;
  border-top: 1px solid #334155;
  /* slate-700 */
  padding-top: 1.5rem;
}

.application-card {
  border: 1px solid #334155;
  /* slate-700 */
  padding: 1rem;
  margin-bottom: 1rem;
  border-radius: 8px;
  background: #0f172a;
  /* slate-950 */
}

.application-card button {
  margin-right: 0.5rem;
  padding: 0.5rem 1rem;
  cursor: pointer;
}

/* Status Badge */
.status-badge {
  padding: 0.25em 0.6em;
  font-size: 0.8rem;
  font-weight: bold;
  border-radius: 10px;
  color: #fff;
  margin-bottom: 1rem;
  display: inline-block;
}

.status-pending {
  background-color: #d97706;
  /* amber-600 */
}

.status-committed {
  background-color: #2563eb;
  /* blue-600 */
}

.status-completed {
  background-color: #059669;
  /* emerald-600 */
}

/* Button Utilities */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  font-weight: 500;
  transition: all 0.2s;
  outline: none;
  border: none;
  cursor: pointer;
}

.btn:focus {
  outline: 2px solid;
  outline-offset: 2px;
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-primary {
  background-color: #4f46e5;
  /* indigo-600 */
  color: white;
}

.btn-primary:hover {
  background-color: #4338ca;
  /* indigo-700 */
}

.btn-primary:focus {
  outline-color: #6366f1;
  /* indigo-500 */
}

.btn-secondary {
  background-color: #334155;
  /* slate-700 */
  color: #f8fafc;
  /* slate-50 */
}

.btn-secondary:hover {
  background-color: #475569;
  /* slate-600 */
}

.btn-secondary:focus {
  outline-color: #94a3b8;
  /* slate-400 */
}

.btn-success {
  background-color: #059669;
  /* emerald-600 */
  color: white;
}

.btn-success:hover {
  background-color: #047857;
  /* emerald-700 */
}

.btn-danger {
  background-color: #dc2626;
  /* red-600 */
  color: white;
}

.btn-danger:hover {
  background-color: #b91c1c;
  /* red-700 */
}

.btn-sm {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
}

.btn-lg {
  padding: 1rem 2rem;
  font-size: 1.125rem;
}

/* Card Utilities */
.card {
  background-color: #1e293b;
  /* slate-800 */
  border-radius: 0.75rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.3);
  border: 1px solid #334155;
  /* slate-700 */
  padding: 1.5rem;
  color: #f1f5f9;
  /* slate-100 */
}

.card h1,
.card h2,
.card h3,
.card h4 {
  color: #fff;
}

.card p {
  color: #94a3b8;
  /* slate-400 */
}

.card-hover {
  transition: transform 0.2s, box-shadow 0.2s;
}

.card-hover:hover {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.4);
  background-color: #252f44;
  /* slightly lighter slate-800 */
  transform: translateY(-2px);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
}

.card-body>*+* {
  margin-top: 1rem;
}

.card-footer {
  padding-top: 1rem;
  border-top: 1px solid #334155;
  /* slate-700 */
  margin-top: 1.5rem;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,4FAA4F;AAC5F;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,6CAA6C;EAC7C,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;AACb;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,+CAA+C;EAC/C,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;;;EAGE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,sBAAsB;AACxB;;AAEA;;;EAGE,0BAA0B;EAC1B,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,uDAAuD;EACvD,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,cAAc;EACd,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,cAAc;EACd,sBAAsB;EACtB,6CAA6C;EAC7C,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;EACzB,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;AACpB","sourcesContent":[".container {\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 0 1rem;\n}\n\n/* Navbar - styles are largely handled by Tailwind in Navbar.js, but keeping defaults safe */\n.navbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 2rem;\n  background-color: #0f172a;\n  /* slate-950 */\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.5);\n  border-bottom: 1px solid #1e293b;\n  /* slate-800 */\n}\n\n.nav-brand {\n  font-size: 1.5rem;\n  font-weight: bold;\n  text-decoration: none;\n  color: #fff;\n}\n\n.nav-links a,\n.nav-links button {\n  margin-left: 1.5rem;\n  text-decoration: none;\n  color: #94a3b8;\n  /* slate-400 */\n  font-size: 1rem;\n  background: none;\n  border: none;\n  cursor: pointer;\n  transition: color 0.2s;\n}\n\n.nav-links a:hover,\n.nav-links button:hover {\n  color: #fff;\n}\n\n/* Forms */\n.form-container {\n  max-width: 400px;\n  margin: 2rem auto;\n  padding: 2rem;\n  background: #1e293b;\n  /* slate-800 */\n  border-radius: 16px;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.5);\n  border: 1px solid #334155;\n  /* slate-700 */\n}\n\n.form-container h2 {\n  margin-top: 0;\n  text-align: center;\n  color: #fff;\n}\n\n.form-container input,\n.form-container textarea,\n.form-container select {\n  width: 100%;\n  padding: 0.8rem;\n  margin-bottom: 1rem;\n  border-radius: 8px;\n  border: 1px solid #334155;\n  /* slate-700 */\n  background: #0f172a;\n  /* slate-950 */\n  color: #fff;\n  box-sizing: border-box;\n}\n\n.form-container input:focus,\n.form-container textarea:focus,\n.form-container select:focus {\n  outline: 2px solid #6366f1;\n  /* indigo-500 or similar */\n  border-color: #6366f1;\n}\n\n.form-container button {\n  width: 100%;\n  padding: 0.8rem;\n  border: none;\n  background: linear-gradient(to right, #4f46e5, #9333ea);\n  color: white;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 1rem;\n  font-weight: 600;\n  transition: opacity 0.2s;\n}\n\n.form-container button:hover {\n  opacity: 0.9;\n}\n\n.error {\n  color: #f87171;\n  /* red-400 */\n  text-align: center;\n  margin-top: 1rem;\n}\n\n/* Job List */\n.job-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 1.5rem;\n}\n\n.job-card {\n  background: #1e293b;\n  /* slate-800 */\n  padding: 1.5rem;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #334155;\n  /* slate-700 */\n  color: #fff;\n}\n\n.job-card h2 {\n  margin-top: 0;\n  color: #f8fafc;\n  /* slate-50 */\n}\n\n.job-card p {\n  color: #cad4e0;\n  /* slate-300 */\n}\n\n.job-card a {\n  margin-top: auto;\n  align-self: flex-end;\n  text-decoration: none;\n  color: #818cf8;\n  /* indigo-400 */\n  font-weight: bold;\n}\n\n/* Job Detail */\n.job-detail-container {\n  background: #1e293b;\n  /* slate-800 */\n  padding: 2rem;\n  border-radius: 12px;\n  border: 1px solid #334155;\n  /* slate-700 */\n  color: #fff;\n}\n\n.applications-section {\n  margin-top: 2rem;\n  border-top: 1px solid #334155;\n  /* slate-700 */\n  padding-top: 1.5rem;\n}\n\n.application-card {\n  border: 1px solid #334155;\n  /* slate-700 */\n  padding: 1rem;\n  margin-bottom: 1rem;\n  border-radius: 8px;\n  background: #0f172a;\n  /* slate-950 */\n}\n\n.application-card button {\n  margin-right: 0.5rem;\n  padding: 0.5rem 1rem;\n  cursor: pointer;\n}\n\n/* Status Badge */\n.status-badge {\n  padding: 0.25em 0.6em;\n  font-size: 0.8rem;\n  font-weight: bold;\n  border-radius: 10px;\n  color: #fff;\n  margin-bottom: 1rem;\n  display: inline-block;\n}\n\n.status-pending {\n  background-color: #d97706;\n  /* amber-600 */\n}\n\n.status-committed {\n  background-color: #2563eb;\n  /* blue-600 */\n}\n\n.status-completed {\n  background-color: #059669;\n  /* emerald-600 */\n}\n\n/* Button Utilities */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.75rem 1.5rem;\n  border-radius: 0.5rem;\n  font-weight: 500;\n  transition: all 0.2s;\n  outline: none;\n  border: none;\n  cursor: pointer;\n}\n\n.btn:focus {\n  outline: 2px solid;\n  outline-offset: 2px;\n}\n\n.btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.btn-primary {\n  background-color: #4f46e5;\n  /* indigo-600 */\n  color: white;\n}\n\n.btn-primary:hover {\n  background-color: #4338ca;\n  /* indigo-700 */\n}\n\n.btn-primary:focus {\n  outline-color: #6366f1;\n  /* indigo-500 */\n}\n\n.btn-secondary {\n  background-color: #334155;\n  /* slate-700 */\n  color: #f8fafc;\n  /* slate-50 */\n}\n\n.btn-secondary:hover {\n  background-color: #475569;\n  /* slate-600 */\n}\n\n.btn-secondary:focus {\n  outline-color: #94a3b8;\n  /* slate-400 */\n}\n\n.btn-success {\n  background-color: #059669;\n  /* emerald-600 */\n  color: white;\n}\n\n.btn-success:hover {\n  background-color: #047857;\n  /* emerald-700 */\n}\n\n.btn-danger {\n  background-color: #dc2626;\n  /* red-600 */\n  color: white;\n}\n\n.btn-danger:hover {\n  background-color: #b91c1c;\n  /* red-700 */\n}\n\n.btn-sm {\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n}\n\n.btn-lg {\n  padding: 1rem 2rem;\n  font-size: 1.125rem;\n}\n\n/* Card Utilities */\n.card {\n  background-color: #1e293b;\n  /* slate-800 */\n  border-radius: 0.75rem;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.3);\n  border: 1px solid #334155;\n  /* slate-700 */\n  padding: 1.5rem;\n  color: #f1f5f9;\n  /* slate-100 */\n}\n\n.card h1,\n.card h2,\n.card h3,\n.card h4 {\n  color: #fff;\n}\n\n.card p {\n  color: #94a3b8;\n  /* slate-400 */\n}\n\n.card-hover {\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.card-hover:hover {\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.4);\n  background-color: #252f44;\n  /* slightly lighter slate-800 */\n  transform: translateY(-2px);\n}\n\n.card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 1rem;\n}\n\n.card-body>*+* {\n  margin-top: 1rem;\n}\n\n.card-footer {\n  padding-top: 1rem;\n  border-top: 1px solid #334155;\n  /* slate-700 */\n  margin-top: 1.5rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
